import {
  Button,
  Col,
  Divider,
  Row,
  Typography,
  Form,
  Input,
  Select,
  Radio,
  Upload,
  message,
  Avatar,
  Tabs,
  Space,
  Image,
  InputNumber,
} from "antd";
import {
  CameraOutlined,
  UserOutlined,
  CloudUploadOutlined,
} from "@ant-design/icons";
import React, { useCallback } from "react";
import deleteIcon from "assets/icons/deletee.svg";
import BackButton from "commons/BackButton";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import SkeletonBlock from "utility/SkeletonBlocks";
import downloadIcon from "assets/icons/downloadIc.svg";
import previewIcon from "assets/icons/previewIc.svg";
import {
  GetPublicFileFromS3,
  uploadPublicFileToS3,
} from "utility/uploadFileToS3";
import {
  aboutPattern,
  cityPattern,
  emailPattern,
  formatNumberUS,
  phonePattern,
  ratingPattern,
  servicesNamePattern,
  streetAddressPattern,
  tenDigit,
  urlPattern,
  zipPattern,
} from "utility/constant";
import {
  GetPhysicalTherapyDetails,
  UpdatePhysicalTherapyDetails,
} from "utility/action";
import SuccessModel from "utility/SuccessModel";
import { API, Storage } from "aws-amplify";
import axios from "axios";

export default function PtCenterDetail() {
  const [ptData, setPtData] = useState([]);
  const [skeletonLoader, setskeletonLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successModel, setSuccessModel] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [key, setKey] = useState("");

  const [uploadImage, setUploadImage] = useState(null);
  const [ptPhoto, setPtPhoto] = useState(null);
  const { TextArea } = Input;
  const location = useLocation();
  const ptId = location?.state.id;
  const [form] = Form.useForm();

  const [imageObject, setImageObject] = useState([]);
  const [activeStatus, setActiveStatus] = useState();
  const [previewIndex, setPreviewIndex] = useState(0);
  const [isPreviewVisible, setPreviewVisible] = useState(false);
  const [preSignedImg, setPreSignedimg] = useState([]);

  const [saveDisabled, setSaveDisabled] = useState(true);
  const handleValuesChange = () => {
    setSaveDisabled(false);
  };

  const [testimonialData, setTestimonialData] = useState([
    { testimonialName: "", testimonialRating: "", review: "" },
  ]);

  const handleAddTestimonial = () => {
    setTestimonialData([
      ...testimonialData,
      { testimonialName: "", testimonialRating: "", review: "" },
    ]);
  };

  const handleupdateTestimonial = (
    index,
    newTestimonialName,
    newTestimonialRating,
    newReview
  ) => {
    const updatedTestimonialData = [...testimonialData];
    updatedTestimonialData[index] = {
      testimonialName: newTestimonialName,
      testimonialRating: newTestimonialRating,
      review: newReview,
    };
    setTestimonialData(updatedTestimonialData);
  };

  const handleDeleteTestimonial = (index) => {
    const updatedFaq = [...testimonialData];
    updatedFaq.splice(index, 1);
    setTestimonialData(updatedFaq);
  };

  const fetchptCenter = useCallback(async () => {
    try {
      setskeletonLoader(true);
      const response = await GetPhysicalTherapyDetails(ptId);
      setActiveStatus(response.activeOnPortal);
      const testimonialData = JSON.parse(response?.testimonial ?? "[]");
      setTestimonialData(testimonialData);
      setPtData(response);
      if (response?.ptProfilePhoto) {
        let ptPhoto;

        if (response?.ptProfilePhoto.startsWith("http")) {
          ptPhoto = response?.ptProfilePhoto;
        } else {
          ptPhoto = await GetPublicFileFromS3(response?.ptProfilePhoto);
        }
        setPtPhoto(ptPhoto);
      }

      if (response?.ptPhotos) {
        const fileKeyy = response?.ptPhotos;
        const urls = [];
        for (const key of fileKeyy) {
          try {
            const url = await Storage.get(key, {
              level: "public",
              expires: 86400,
            });
            urls.push(url);
          } catch (error) {
            console.log(`Error getting pre-signed URL for ${key}: ${error}`);
          }
        }
        setPreSignedimg(urls);
      }
    } catch (error) {
      messageApi.open({
        type: "error",
        content: "Something went wrong",
      });
      console.log(error);
    } finally {
      setskeletonLoader(false);
    }
  }, [ptId]);

  useEffect(() => {
    fetchptCenter();
  }, [fetchptCenter]);

  const updatePtCenter = async (values) => {
    try {
      setLoading(true);
      const testJson = JSON.stringify(testimonialData);
      const inputData = {
        id: ptData?.id,
        testimonial: testJson,
        ptName: values?.ptName,
        ptPhone: values?.ptPhone,
        ptFax: values?.ptFax,
        ptWebsite: values?.ptWebsite,
        ptAddLine1: values?.ptAddLine1,
        ptAddLine2: values?.ptAddLine2,
        ptAddLine3: values?.ptAddLine3,
        ptZipCode: values?.ptZipCode,
        ptEmail: values?.ptEmail,
        aboutPT: values?.aboutPT,
        ptMapSource: values?.ptMapSource,
        ptProfilePhoto: key === "" ? undefined : key,
        ptFaceBookRating: values?.ptFaceBookRating,
        ptGoogleRating: values?.ptGoogleRating,
        ptOccupationalTherapy: values?.ptOccupationalTherapy,
        activeOnPortal: values?.activeOnPortal,
      };

      await UpdatePhysicalTherapyDetails(inputData);
      fetchptCenter();
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
      }, 3000);
    } catch (error) {
      messageApi.open({
        type: "error",
        content: "Something went wrong",
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const updatePtCenterPhotos = async (values) => {
    try {
      setLoading(true);
      let existingImages = ptData?.ptPhotos || [];
      const inputData = {
        id: ptData?.id,
        ptPhotos: [...existingImages, ...imageObject],
      };

      await UpdatePhysicalTherapyDetails(inputData);
      fetchptCenter();
      setSuccessModel(true);
      form.resetFields();
      setTimeout(() => {
        setSuccessModel(false);
      }, 3000);
    } catch (error) {
      messageApi.open({
        type: "error",
        content: "Something went wrong",
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const initialValues = {
    ptName: ptData?.ptName,
    ptPhone: ptData?.ptPhone,
    ptFax: ptData?.ptFax,
    ptWebsite: ptData?.ptWebsite,
    ptAddLine1: ptData?.ptAddLine1,
    ptAddLine2: ptData?.ptAddLine2,
    ptAddLine3: ptData?.ptAddLine3,
    ptZipCode: ptData?.ptZipCode,
    ptEmail: ptData?.ptEmail,
    aboutPT: ptData?.aboutPT,
    ptMapSource: ptData?.ptMapSource,
    ptFaceBookRating: ptData?.ptFaceBookRating,
    ptGoogleRating: ptData?.ptGoogleRating,
    ptOccupationalTherapy: ptData?.ptOccupationalTherapy,
    activeOnPortal: ptData?.activeOnPortal,
    testimonial:
      testimonialData && testimonialData.length > 0
        ? testimonialData.map((item, index) => ({
            [`testimonialName_${index}`]: item?.testimonialName,
            [`testimonialRating_${index}`]: item?.testimonialRating,
            [`review_${index}`]: item?.review,
          }))
        : [{ testimonialName_0: "", testimonialRating_0: "", review_0: "" }],
  };

  function UserImg() {
    return (
      <img
        src={uploadImage === null ? ptPhoto : uploadImage}
        className="user-img"
        alt="Profile"
        style={{ margin: "none" }}
      />
    );
  }

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const props = {
    onChange({ file }) {
      setSaveDisabled(false);
      if (file.status === "uploading") {
        messageApi.open({
          key: "member",
          type: "loading",
          content: `Uploading Image`,
          duration: 0,
        });
      }
      if (file.status === "done") {
        messageApi.open({
          key: "member",
          type: "success",
          content: `Image Uploaded Successfully`,
          duration: 5,
        });
      }
    },
    async customRequest({ file, onError, onSuccess }) {
      try {
        const linkToUpload = await API.get(
          "bazarhealthREST",
          `/superAdmin/generateS3PutPresignedUrl`
        );

        const response = await axios.put(linkToUpload, file);
        // uploadPublicFileToS3(file)
        //   .then(async (res) => {
        //     const link = await GetPublicFileFromS3(res.key);
        setUploadImage(linkToUpload.split("?")[0]);
        setKey(linkToUpload.split("?")[0]);
        onSuccess();
      } catch (error) {
        onError();
      }
    },
  };

  const IcImagesProps = {
    customRequest({ file, onError, onSuccess }) {
      uploadPublicFileToS3(file)
        .then(async (res) => {
          setImageObject((item) => [...item, res.key]);
          onSuccess();
        })
        .catch(() => {
          onError();
        });
    },
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const onDelete = async (index) => {
    const newImageObject = [...imageObject];
    const deletedKey = newImageObject.splice(index, 1)[0];
    try {
      await Storage.remove(deletedKey, { level: "public" });
      setImageObject(newImageObject);
      const updatedImages = preSignedImg.filter((img, i) => i !== index);
      setPreSignedimg(updatedImages);

      messageApi.success({
        content: "Image Deleted Successfully",
        duration: 5,
      });
    } catch (error) {
      console.log("Error deleting image from S3:", error);
      messageApi.error({
        content: "Error Deleting Image",
      });
    }
  };

  const activeOnPortal = (e) => {
    setActiveStatus(e.target.value);
  };

  return (
    <>
      {contextHolder}
      <Row justify="space-between">
        <BackButton />
        <Typography.Title level={4} className="text-center mb-0">
          {ptData?.ptName}
        </Typography.Title>
        <Button style={{ marginLeft: 110 }}></Button>
        <Divider style={{ margin: "8px 0" }} />
      </Row>

      <Row className="service-detail-tab">
        <Tabs defaultActiveKey="1" tabPosition="left" className="w-100">
          <Tabs.TabPane tab="Details" key="1">
            <Row justify="start">
              <Col span={20} md={20} xs={24} sm={24}>
                {skeletonLoader ? (
                  <>
                    <Row gutter={[20, 20]} className="mt-3">
                      <SkeletonBlock style={{ width: 700, height: 50 }} />
                      <SkeletonBlock style={{ width: 700, height: 50 }} />
                      <SkeletonBlock style={{ width: 700, height: 50 }} />
                      <SkeletonBlock style={{ width: 700, height: 50 }} />
                      <SkeletonBlock style={{ width: 700, height: 50 }} />
                      <SkeletonBlock style={{ width: 700, height: 50 }} />
                      <SkeletonBlock style={{ width: 700, height: 200 }} />
                    </Row>
                  </>
                ) : (
                  <>
                    <Row
                      justify="center"
                      className="mt-20 upload-services-photo"
                    >
                      <div className="relative">
                        <Avatar
                          size={120}
                          icon={
                            ptPhoto === null && uploadImage === null ? (
                              <UserOutlined />
                            ) : (
                              <UserImg />
                            )
                          }
                        />
                        <Upload
                          {...props}
                          showUploadList={false}
                          beforeUpload={beforeUpload}
                          className="avatar-uploader"
                        >
                          <Button
                            shape="circle"
                            size="middle"
                            className="btn-primary-dual-color upload-btn"
                          >
                            <CameraOutlined />
                          </Button>
                        </Upload>
                      </div>
                    </Row>
                    <Row className="update-form">
                      <Form
                        name="basic"
                        initialValues={initialValues}
                        onFinish={updatePtCenter}
                        autoComplete="off"
                        layout="vertical"
                        className="mt-30"
                        onValuesChange={handleValuesChange}
                      >
                        <Row gutter={20}>
                          <Col span={12} md={12} xs={24} sm={24}>
                            <Form.Item
                              label="Name"
                              name="ptName"
                              rules={[
                                {
                                  pattern: servicesNamePattern,
                                  message: "Please enter a valid name",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col span={12} md={12} xs={24} sm={24}>
                            <Form.Item
                              label="Website"
                              name="ptWebsite"
                              rules={[
                                {
                                  pattern: urlPattern,
                                  message: "Please input valid url",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col span={12} md={12} xs={24} sm={24}>
                            <Form.Item
                              label="Email"
                              name="ptEmail"
                              rules={[
                                {
                                  pattern: emailPattern,
                                  message: "Please enter a valid email",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col span={12} md={12} xs={24} sm={24}>
                            <Form.Item
                              label="Phone"
                              name="ptPhone"
                              rules={[
                                {
                                  pattern: tenDigit,
                                  message: "Please enter a valid phone number",
                                },
                              ]}
                            >
                              <InputNumber
                                controls={false}
                                formatter={(value) => {
                                  return formatNumberUS(value);
                                }}
                                parser={(value) => {
                                  const cleanedValue = value.replace(/\D/g, "");
                                  return cleanedValue.slice(0, 10);
                                }}
                                style={{ width: "100%", borderRadius: "5px" }}
                              />
                            </Form.Item>
                          </Col>

                          {/* adding field for fax */}
                          <Col span={12} md={12} xs={24} sm={24}>
                            <Form.Item
                              label="Fax"
                              name="ptFax"
                              rules={[
                                {
                                  pattern: tenDigit,
                                  message: "Please enter a valid fax number",
                                },
                              ]}
                            >
                              <InputNumber
                                controls={false}
                                formatter={(value) => {
                                  return formatNumberUS(value);
                                }}
                                parser={(value) => {
                                  const cleanedValue = value.replace(/\D/g, "");
                                  return cleanedValue.slice(0, 10);
                                }}
                                style={{ width: "100%", borderRadius: "5px" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={24} md={24} xs={24} sm={24}>
                            <Form.Item
                              label="About"
                              name="aboutPT"
                              rules={[
                                {
                                  pattern: aboutPattern,
                                  message: "Please enter a valid about",
                                },
                              ]}
                            >
                              <TextArea rows={4} />
                            </Form.Item>
                          </Col>

                          <Col span={12} md={12} xs={24} sm={24}>
                            <Form.Item
                              label="Street address"
                              name="ptAddLine1"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter street address",
                                },
                                {
                                  pattern: streetAddressPattern,
                                  message:
                                    "Please enter a valid street address",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col span={12} md={12} xs={24} sm={24}>
                            <Form.Item
                              label="City"
                              name="ptAddLine2"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter city name",
                                },
                                {
                                  pattern: cityPattern,
                                  message: "Please enter a valid city name",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col span={12} md={12} xs={24} sm={24}>
                            <Form.Item
                              label="State"
                              name="ptAddLine3"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter state name",
                                },
                                {
                                  pattern: cityPattern,
                                  message: "Please enter a valid state name",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col span={12} md={12} xs={24} sm={24}>
                            <Form.Item
                              label="Zip code"
                              name="ptZipCode"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter zip code",
                                },
                                {
                                  pattern: zipPattern,
                                  message: "Please enter a valid ZIP code",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col span={24} md={24} xs={24} sm={24}>
                            <Form.Item
                              label="Google map link"
                              name="ptMapSource"
                              rules={[
                                {
                                  // pattern: urlPattern,
                                  message: "Please input valid url",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>

                          <Col span={12} md={12} xs={24} sm={24}>
                            <Form.Item
                              label="Google rating"
                              name="ptGoogleRating"
                              rules={[
                                {
                                  pattern: ratingPattern,
                                  message:
                                    "Please enter a valid rating between 0 and 10",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>

                          <Col span={12} md={12} xs={24} sm={24}>
                            <Form.Item
                              label="Facebook rating"
                              name="ptFaceBookRating"
                              rules={[
                                {
                                  pattern: ratingPattern,
                                  message:
                                    "Please enter a valid rating between 0 and 10",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>

                          <Col span={24} md={24} xs={24} sm={24}>
                            {initialValues?.testimonial?.map((item, index) => (
                              <div key={index}>
                                <Row gutter={[16, 16]}>
                                  <Col span={12}>
                                    <Form.Item
                                      label={`Testimonial name ${index + 1}`}
                                      name={`testimonialName_${index}`}
                                      initialValue={
                                        item[`testimonialName_${index}`]
                                      }
                                      rules={[
                                        {
                                          pattern: servicesNamePattern,
                                          message: "Please enter a valid name",
                                        },
                                      ]}
                                    >
                                      <Input
                                        onChange={(e) =>
                                          handleupdateTestimonial(
                                            index,
                                            e.target.value,
                                            item[`testimonialRating_${index}`],
                                            item[`review_${index}`]
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col span={12}>
                                    <Form.Item
                                      label={`Testimonial rating ${index + 1}`}
                                      name={`testimonialRating_${index}`}
                                      initialValue={
                                        item[`testimonialRating_${index}`]
                                      }
                                      rules={[
                                        {
                                          pattern: ratingPattern,
                                          message:
                                            "Please enter a valid rating between 0 and 10",
                                        },
                                      ]}
                                    >
                                      <Input
                                        onChange={(e) =>
                                          handleupdateTestimonial(
                                            index,
                                            item[`testimonialName_${index}`],
                                            e.target.value,
                                            item[`review_${index}`]
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>

                                <Form.Item
                                  label={`Review ${index + 1}`}
                                  name={`review_${index}`}
                                  initialValue={item[`review_${index}`]}
                                  rules={[
                                    {
                                      pattern: aboutPattern,
                                      message: "Please enter a valid review",
                                    },
                                  ]}
                                >
                                  <Input.TextArea
                                    onChange={(e) =>
                                      handleupdateTestimonial(
                                        index,
                                        item[`testimonialName_${index}`],
                                        item[`testimonialRating_${index}`],
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>

                                {initialValues?.testimonial.length > 1 && (
                                  <Row justify="space-between table-header">
                                    <Row align="middle">
                                      <Typography.Title
                                        level={5}
                                      ></Typography.Title>
                                    </Row>
                                    <Row align="middle">
                                      <Typography.Text
                                        className="hover-thumb"
                                        level={3}
                                        onClick={() =>
                                          handleDeleteTestimonial(index)
                                        }
                                        style={{ color: "red" }}
                                      >
                                        <u>Delete</u>
                                      </Typography.Text>
                                    </Row>
                                  </Row>
                                )}
                              </div>
                            ))}

                            <Typography.Text
                              level={3}
                              onClick={handleAddTestimonial}
                              className="hover-thumb add-more-reviews"
                            >
                              <u>+ Add more testimonials</u>
                            </Typography.Text>
                          </Col>

                          <Col
                            span={12}
                            md={12}
                            xs={24}
                            sm={24}
                            className="mt-20"
                          >
                            <Form.Item
                              label="Account status"
                              name="activeOnPortal"
                            >
                              <Radio.Group onChange={activeOnPortal}>
                                <Radio value={true}>Active</Radio>
                                <Radio value={false}>Inactive</Radio>
                              </Radio.Group>
                            </Form.Item>
                          </Col>
                          <Col
                            span={12}
                            md={12}
                            xs={24}
                            sm={24}
                            className="mt-20"
                          >
                            <Form.Item
                              label="Offers occupational therapy?"
                              name="ptOccupationalTherapy"
                            >
                              <Radio.Group>
                                <Radio value={true}>Yes</Radio>
                                <Radio value={false}>No</Radio>
                              </Radio.Group>
                            </Form.Item>
                          </Col>

                          <Col
                            span={24}
                            md={24}
                            xs={24}
                            sm={24}
                            className="center-btn"
                          >
                            <Button
                              size="large"
                              className="theme-btn mt-20"
                              htmlType="submit"
                              loading={loading}
                              disabled={saveDisabled}
                            >
                              Save
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Row>
                  </>
                )}
              </Col>
            </Row>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Images" key="2">
            <Form
              onFinish={updatePtCenterPhotos}
              autoComplete="off"
              layout="vertical"
              form={form}
            >
              <Row>
                <Col span={20} md={24} xs={24} sm={24}>
                  <Row gutter={[20, 20]}>
                    {preSignedImg.map((image, index) => (
                      <Col span={8} md={8} xs={24} sm={24}>
                        <div key={index} className="service-image-preview">
                          <Image
                            src={image}
                            className="service-image-preview-img"
                            onClick={() => setPreviewIndex(index)}
                            preview={{
                              visible:
                                isPreviewVisible && previewIndex === index,
                              onVisibleChange: (visible, prevVisible) => {
                                if (!visible) setPreviewIndex(null);
                                setPreviewVisible(visible);
                              },
                            }}
                          />
                          <div className="hide-icon">
                            <Space>
                              <img
                                src={previewIcon}
                                alt="preview-icon"
                                onClick={() => {
                                  setPreviewIndex(index);
                                  setPreviewVisible(true);
                                }}
                              />
                              <a href={image} download>
                                <img src={downloadIcon} alt="download-icon" />
                              </a>
                              <a onClick={() => onDelete(index)}>
                                <img src={deleteIcon} alt="download-icon" />
                              </a>
                            </Space>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                  <Form.Item name="files">
                    <Upload
                      listType="picture-card"
                      onPreview={onPreview}
                      className="basic-img-upload"
                      {...IcImagesProps}
                      beforeUpload={beforeUpload}
                    >
                      <CloudUploadOutlined /> Click here to upload image
                    </Upload>
                  </Form.Item>
                </Col>
                <Col span={24} md={24} xs={24} sm={24} className="center-btn">
                  <Button
                    size="large"
                    className="theme-btn mt-20"
                    htmlType="submit"
                    loading={loading}
                  >
                    Save
                  </Button>
                </Col>
              </Row>
            </Form>
          </Tabs.TabPane>
        </Tabs>
      </Row>

      <SuccessModel
        message="PT Center Updated Successfully"
        open={successModel}
      />
    </>
  );
}
